import { DateTime } from 'luxon';

import { SettingsState } from '@/store';

function date(value: string | Date, onlyDate: boolean = false): string {
    // TODO: avoid such behavior?
    if (!value) {
        return '';
    }

    const dateTime = value instanceof Date ? value : new Date(value);
    const offset = SettingsState.contextSettings.global.timeOffset || 0;
    const offsetSign = offset >= 0 ? '+' : '';
    const shortFormat = SettingsState.contextSettings.global.formatDate || 'yyyy-MM-dd';
    const timeFormat = SettingsState.contextSettings.global.formatTime || 'HH:mm';
    const longFormat = shortFormat + ' ' + timeFormat;

    return DateTime
        .fromISO(dateTime.toISOString(), { zone: 'UTC' + offsetSign + offset })
        .toFormat(onlyDate ? shortFormat : longFormat);
}

export default date;
